import React from "react";
import ReduxServices from "Utils/globalRedux";
import { convertWeiToBalance } from "Utils/globalFunction";
import { Button } from "antd";
import "./view.styles.css";
import configg from "../../../config";
import Content from "./content";
import Web3Services from "Backend/Web3";
import numeral from "numeral";
// Warn if overriding existing method
if (Array.prototype.equals)
  console.warn(
    "Overriding existing Array.prototype.equals. Possible causes: New API defines the method, there's a framework conflict or you've got double inclusions in your code."
  );
// attach the .equals method to Array's prototype to call it on any array
Array.prototype.equals = function (array) {
  // if the other array is a falsy value, return
  if (!array) return false;

  // compare lengths - can save a lot of time
  if (this.length != array.length) return false;

  for (var i = 0, l = this.length; i < l; i++) {
    // Check if we have nested arrays
    if (this[i] instanceof Array && array[i] instanceof Array) {
      // recurse into the nested arrays
      if (!this[i].equals(array[i])) return false;
    } else if (this[i] != array[i]) {
      // Warning - two different object instances will never be equal: {x:20} != {x:20}
      return false;
    }
  }
  return true;
};
// Hide method from for-in loops
Object.defineProperty(Array.prototype, "equals", { enumerable: false });
const abiGetBalance = [
  {
    constant: true,
    inputs: [
      {
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOfNFT",
    outputs: [
      {
        name: "",
        type: "uint256",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  {
    constant: true,
    inputs: [
      {
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        name: "",
        type: "uint256",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
];

const abiBalanceOf = [
  {
    constant: true,
    inputs: [
      {
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        name: "",
        type: "uint256",
      },
    ],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
];

const PANTOLIGHT_ADDRESS_CONTRACT =
  "0x161131a7680010c21aed590c066ad69044c56e74";
const PANTODRAW_ADDRESS_CONTRACT = "0xb3dfe03e45135be59cdfd53b839f9bcfd1a5102d";

const getBalanceFromAddress = (web3, addressToken, addressUser) =>
  new Promise(async (resolve, reject) => {
    const trc721Contract = new web3.eth.Contract(abiGetBalance, addressToken);
    try {
      const balance = await trc721Contract.methods
        .balanceOfNFT(addressUser)
        .call();
      resolve(balance);
    } catch (err) {
      try {
        const balance = await trc721Contract.methods
          .balanceOf(addressUser)
          .call();
        resolve(balance);
      } catch (err) {
        resolve(null);
        reject("Cannot get balance");
      }
    }
  });

export default class MainScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      config: null,
      balance: "",
      listAllTrc21: [],
      listAllTrc721: [],
      isShowPanto: null,
      wp_address: [],
      wp_amount: [],
      wp_is_validate_both: false,
    };
    this.checkExist = setInterval(() => {
      let newState = {};
      if (document.wp_address !== undefined) {
        newState.wp_address = document.wp_address;
        newState.wp_amount = document.wp_amount;
        if (document.wp_is_validate_both !== undefined) {
          newState.wp_is_validate_both = document.wp_is_validate_both;
        }
        this.setState(newState);
        clearInterval(this.checkExist);
      }
    }, 200);
    props.defaultThis(this);
  }

  checkExistInterval = (that) => {
    let newState = {};
    if (document.wp_address !== undefined) {
      newState.wp_address = document.wp_address;
      newState.wp_amount = document.wp_amount;
      if (document.wp_is_validate_both !== undefined) {
        newState.wp_is_validate_both = document.wp_is_validate_both;
      }
      that.setState(newState);
      clearInterval(this.checkExist);
    }
  };

  async componentDidMount() {
    console.log("componentDidMount");
    if (document.wp_address == undefined) {
      this.checkExist = setInterval(() => this.checkExistInterval(this), 200);
    }
    this.props.loadingInitial();
    const netid = await Web3Services.getNetwork();
    console.log(netid);
    if (this.props.userAuth.address) {
      this.getPantoCondition();
      await this.getAllTokenTrc21(this.props.userAuth.address);
      await this.getAllTokenTrc721(this.props.userAuth.address);
      const balance = await Web3Services.getTomoBalance(
        this.props.userAuth.address
      );
      this.setState({ balance });
    }
    const balance = await this.setState({
      config: configg[netid],
    });
  }

  async getAllTokenTrc21(address) {
    const tomoTrc21 = await fetch(
      `https://scan.tomochain.com/api/tokens/holding/trc21/${address}?page=1&limit=1`
    ).then((res) => res.json());
    const numPage = Math.round(tomoTrc21.total / 50);
    var listAllTrc21Promise = [];
    for (var i = 1; i <= numPage; i++) {
      listAllTrc21Promise.push(
        fetch(
          `https://scan.tomochain.com/api/tokens/holding/trc21/${address}?page=${i}&limit=50`
        ).then((res) => res.json())
      );
    }
    if (numPage == 0) {
      listAllTrc21Promise.push(
        fetch(
          `https://scan.tomochain.com/api/tokens/holding/trc21/${address}?page=1&limit=50`
        ).then((res) => res.json())
      );
    }
    var listAllTrc21PromiseResult = await Promise.all(listAllTrc21Promise);
    var listAllTrc21 = [];
    listAllTrc21PromiseResult.forEach((item) => {
      listAllTrc21 = [...listAllTrc21, ...item.items];
    });
    listAllTrc21 = listAllTrc21.filter((item) => item.quantityNumber !== 0);
    this.setState({ listAllTrc21 });
  }

  async getAllTokenTrc721(address) {
    const tomoTrc721 = await fetch(
      `https://api.pantograph.app/setting/games-list`
    ).then((res) => res.json());
    const web3 = await Web3Services.web3Read();
    var listAllTrc721 = [];
    var listBalancePromise = [];
    tomoTrc721.forEach((item) => {
      listBalancePromise.push(
        getBalanceFromAddress(web3, item.address, this.props.userAuth.address)
      );
    });
    listBalancePromise = await Promise.all(listBalancePromise);
    listAllTrc721 = listBalancePromise.map((balance, idx) => ({
      balance,
      ...tomoTrc721[idx],
    }));
    listAllTrc721 = listAllTrc721.filter((item) => item.balance != "0");
    console.log("listAllTrc721", listAllTrc721);
    this.setState({ listAllTrc721 });
    // console.log("trc721Contract", balance);
    // console.log('trc721Contract',trc721Contract)
    // const t = await trc721Contract
    // console.log('trc721Contract',trc721Contract.methods)
    // console.log("tomoTrc721", tomoTrc721);
  }
  async getPantoCondition() {
    var flag = true;
    const web3 = await Web3Services.web3Read();
    var count_passed_condition = 0;
    var lengthOfaddress = this.state.wp_address.length;
    if (
      document.wp_max_address &&
      document.wp_max_address < this.state.wp_address.length
    ) {
      lengthOfaddress = document.wp_max_address;
    }
    for (let i = 0; i < lengthOfaddress; i++) {
      const address = this.state.wp_address[i];
      const amount = this.state.wp_amount[i];
      if (Web3Services.isValidAddressFormat(address)) {
        var passed = false;
        try {
          const contractGetBalance = new web3.eth.Contract(
            abiBalanceOf,
            address
          );
          const balanceOfUser = await contractGetBalance.methods
            .balanceOf(this.props.userAuth.address)
            .call();

          let textDebug = `balanceOfUser address token ${address} .ok
          ${convertWeiToBalance(balanceOfUser)} `;
          if (
            balanceOfUser &&
            !isNaN(amount) &&
            amount !== "" &&
            amount <= convertWeiToBalance(balanceOfUser)
          ) {
            passed = true;
            textDebug += " pass trc21";
          } else {
            textDebug += "not pass trc21";
          }
          console.log(textDebug);
        } catch (err) {
          console.log(
            `Cannot get balanceOfUser trc21 address token ${address}`
          );
          console.log(`[ERROR]:${err}`);
        }
        const balanceNFT721 = await getBalanceFromAddress(
          web3,
          address,
          this.props.userAuth.address
        );
        if (balanceNFT721) {
          console.log("balanceNFT721", balanceNFT721);
          if (amount <= balanceNFT721) {
            console.log("pass trc721");
            passed = true;
          }
        }
        if (passed) {
          count_passed_condition++;
        }
      }
    }
    console.log("count_passed_condition", count_passed_condition);
    console.log("lengthOfaddress", lengthOfaddress);
    if (count_passed_condition < lengthOfaddress) {
      flag = false;
    }
    if (this.props.userAuth.address) {
      document.wp_flag_sign_content = flag;
    }
    this.setState({ isShowPanto: flag });
  }

  callbackFunction = async () => {
    this.setState({
      balance: "",
      listAllTrc21: [],
      listAllTrc721: [],
      isShowPanto: null,
    });
    if (this.props.userAuth.address) {
      const balance = await Web3Services.getTomoBalance(
        this.props.userAuth.address
      );
      this.getPantoCondition();
      await this.getAllTokenTrc21(this.props.userAuth.address);
      await this.getAllTokenTrc721(this.props.userAuth.address);
      this.setState({ balance });
    }
    // alert("OK");
  };

  handleSignPantograph = () => {
    ReduxServices.loginMetamask(this.callbackFunction, this.props.t);
  };

  async componentDidUpdate(prevProps, prevState) {
    if (
      !this.state.wp_address.equals(prevState.wp_address) ||
      !this.state.wp_amount.equals(prevState.wp_amount)
    ) {
      this.getPantoCondition();
    }
    if (this.props.userAuth.address !== prevProps.userAuth.address) {
      console.log("componentDidUpdate");
      document.wp_flag_sign_content = undefined;
      await this.getAllTokenTrc21(this.props.userAuth.address);
      await this.getAllTokenTrc721(this.props.userAuth.address);
      const balance = await Web3Services.getTomoBalance(
        this.props.userAuth.address
      );
      this.setState({ balance });
    }
  }

  render() {
    const { userAuth, metamask } = this.props;

    return userAuth.address ? (
      <div></div>
    ) : (
      // <div style={{ textAlign: "center" }}>
      //   <div>
      //     <br></br>
      //     <div>
      //       <b>Address:</b>{" "}
      //       <a
      //         href={"https://scan.tomochain.com/address/" + userAuth.address}
      //         target="_blank"
      //       >
      //         {" "}
      //         {userAuth.address}
      //       </a>
      //     </div>
      //     <div>
      //       <b>Balance:</b> {this.state.balance}
      //     </div>
      //     <br></br>
      //     <div style={{ display: "flex", justifyContent: "center" }}>
      //       <div className="table-trc" style={{ display: "inline-block" }}>
      //         <div className="trc21">
      //           <table>
      //             <thead>
      //               <tr>
      //                 <th style={{ textAlign: "center" }} colSpan="3">
      //                   List Trc21 - Mainnet
      //                 </th>
      //               </tr>
      //               <tr>
      //                 <th>Token Name</th>
      //                 <th>Token Address</th>
      //                 <th>Balance</th>
      //               </tr>
      //             </thead>
      //             <tbody>
      //               {this.state.listAllTrc21.map((item, key) => (
      //                 <tr key={key}>
      //                   <td>
      //                     <b>{item.tokenObj.name}</b>
      //                   </td>
      //                   <td>
      //                     <b>
      //                       {
      //                         <a
      //                           href={
      //                             "https://scan.tomochain.com/address/" +
      //                             item.token
      //                           }
      //                           target="_blank"
      //                         >
      //                           {" "}
      //                           {item.token}
      //                         </a>
      //                       }
      //                     </b>
      //                   </td>
      //                   <td>
      //                     {numeral(item.quantityNumber).format("0,0.0000")}
      //                   </td>
      //                 </tr>
      //               ))}
      //             </tbody>
      //           </table>
      //         </div>
      //       </div>
      //       <div
      //         className="table-trc"
      //         style={{ display: "inline-block", marginLeft: "10px" }}
      //       >
      //         <div className="trc21">
      //           <table>
      //             <thead>
      //               <tr>
      //                 <th style={{ textAlign: "center" }} colSpan="3">
      //                   List Trc721 - Mainnet
      //                 </th>
      //               </tr>
      //               <tr>
      //                 <th>Token Name</th>
      //                 <th>Token Address</th>
      //                 <th>Balance</th>
      //               </tr>
      //             </thead>
      //             <tbody>
      //               {this.state.listAllTrc721.map((item, key) => (
      //                 <tr key={key}>
      //                   <td>
      //                     <b>{item.gameName}</b>
      //                   </td>
      //                   <td>
      //                     <b>
      //                       {
      //                         <a
      //                           href={
      //                             "https://scan.tomochain.com/address/" +
      //                             item.address
      //                           }
      //                           target="_blank"
      //                         >
      //                           {" "}
      //                           {item.address}
      //                         </a>
      //                       }
      //                     </b>
      //                   </td>
      //                   <td>{numeral(item.balance).format("0,0")}</td>
      //                 </tr>
      //               ))}
      //             </tbody>
      //           </table>
      //         </div>
      //       </div>
      //     </div>
      //   </div>
      //   {/* {this.state.isShowPanto == true ? (
      //     <div
      //       style={{
      //         width: "800px",
      //         display: "inline-block",
      //         marginTop: "10px",
      //       }}
      //     >
      //       <img
      //         style={{ width: "100%" }}
      //         src="https://ipfs.pantograph.app/ipfs/QmRnF6H6vknzaET6xBhnvE1uba2nhjZVhHbpS8X298YfFP?filename=Screen%20Shot%202020-08-07%20at%204.21.38%20PM.png"
      //       />
      //     </div>
      //   ) : null}
      //   {this.state.isShowPanto == false ? (
      //     <div style={{ marginTop: "10px" }}>
      //       ニュースを見るためにPantoPointかPantoDrawを1枚以上所有する必要があります。
      //       購入サイト：
      //       <br />
      //       <a
      //         href={"https://demo.pantograph.app/panto-market"}
      //         target="_blank"
      //       >
      //         https://demo.pantograph.app/panto-market
      //       </a>
      //     </div>
      //   ) : null} */}
      // </div>
      <button
        className="btn button-sign-pantograph"
        onClick={this.handleSignPantograph}
      >
        Sign Pantograph
      </button>
    );
  }
}

// document.wp_amount = [83,0]
// document.wp_address=["0x161131a7680010c21aed590c066ad69044c56e74", "0x043bd4b9c8f93d3c8c220d1fb7b3eb961d24cbf7"]
